import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'me',
    path: '/me',
    component: () => import(/* webpackChunkName: "user" */ '../components/user/UserDetails.vue'),
  },
] as RouteConfig[];
